(function ($, Drupal) {
  Drupal.behaviors.sidebar = {
    attach: function sidebar(context, settings) {
      if (typeof context['location'] !== 'undefined') {

        $(document).ready(function() {
          function sidebarResize() {
            if ($('.block--sidebar-menu--sidebar').length && $(window).width() < 1024) {
              $('.block--sidebar-menu---mobile--sidebar-mobile').css('display', 'block');
            }
            else {
              $('.block--sidebar-menu---mobile--sidebar-mobile').css('display', 'none');
            }
          }

          var children = $('.block--sidebar-menu--sidebar .nav--main, .block--sidebar-menu---mobile--sidebar-mobile .nav--main').children();
          var activeMenuPresent = ($('.block--sidebar-menu--sidebar .nav--main .is-active-trail, .block--sidebar-menu---mobile--sidebar-mobile .nav--main .is-active-trail').length > 0) ? true : false;

          if (activeMenuPresent) {
            $.each(children, function (index) {
              if (!$(this).hasClass('is-active-trail')) {
                $(this).remove();
              }
            });
          }

          sidebarResize();
          var sidebarDebounce = Drupal.debounce(function() {
            sidebarResize();
          }, 250);
          window.addEventListener('resize', sidebarDebounce);

          $('.block--sidebar-menu---mobile--sidebar-mobile .nav__link.has-subnav').click(function(event) {
            event.preventDefault();
            var header = $(this);
            //getting the next element
            var content = header.siblings('.nav__subnav');

            //open up the content needed - toggle the slide- if visible, slide up, if not slidedown.
            content.slideToggle(500, function() {
              if (content.css('display') == 'block') {
                header.siblings('.nav__subnav--arrow').css({'transform': 'rotate(180deg)', 'translate': '0, -100%;'});
              }
              else {
                header.siblings('.nav__subnav--arrow').css({'transform': 'rotate(0deg)', 'translate': '0, 100%;'});
              }
            });
          });

          // Long press event on headers.
          document.querySelectorAll('.block--sidebar-menu---mobile--sidebar-mobile .nav__link.has-subnav')
            .forEach(link => {
              if ('A' !== link.nodeName) { return }
              link.addEventListener('long-press', function(e) {
                e.preventDefault();
                console.log(e.target);
                window.location.assign(e.target);
              })
            });
        });

        /*
        * Sidebar Scroll pin
        */
        $(window).on('load', function () {
          var hasFixedAdminToolbar = $('body').hasClass('toolbar-fixed');
          var adminToolbarHeight = (hasFixedAdminToolbar) ? parseInt($('body').css('padding-top'), 10) : 0;
          var preHeaderOffsetHeight = $('#primaryNavigation').outerHeight();
          var topOffset = adminToolbarHeight + preHeaderOffsetHeight;

          var zp_nav_sidebar = new $.Zebra_Pin($('.pinned-sidebar'), {
            class_name: 'sidebar-pin',
            contain: true,
            z_index: 480,
            top_spacing: topOffset,
          });

          // Update zebra pin on resize
          function resizePin() {
            var hasFixedAdminToolbar = $('body').hasClass('toolbar-fixed');
            var adminToolbarHeight = (hasFixedAdminToolbar) ? parseInt($('body').css('padding-top'), 10) : 0;

            // Set updated mobile navbar height on viewport change
            zp_nav_sidebar.settings.top_spacing = topOffset;
            zp_nav_sidebar.update();
          }

          // Debounce screen resize event
          var zebrapin;
          window.addEventListener('resize', function() {
            clearTimeout(zebrapin);
            zebrapin = setTimeout(resizePin, 100);
          });
        });
      }
    }
  };
})(jQuery, Drupal, window, document);
